import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { betReplayService } from '../../../../services/betReplayService';
import { soundService, SoundTypes } from '../../../../services/soundService';

import { Spine } from '../../../../core/classes/spine';
import { isMobile } from '../../../../core/helpers/isMobile';

import { jackPotStore } from '../../../../store/jackPotStore';
import { userInfoStore } from '../../../../store/userInfoStore';
import { applicationStore } from '../../../../store/applicationStore';
import { gameStore } from '../../../../store/gameStore';
import { gameGlobalStates } from '../../../../core/constants/reelConstants';

const JackPotCongratsPopup = observer(() => {
  const jackPotCongratsPopupRef = useRef(null);
  const { isShowJackpot, setIsShowJackpotScene } = jackPotStore;

  const hideJackPotCongratsPopup = useCallback(() => {
    jackPotCongratsPopupRef.current.children[0].play('end');
    jackPotCongratsPopupRef.current.children[0].addListener(
      'whiteEnd',
      () => {
        if (userInfoStore.isReplay) {
          betReplayService.startReplayJackpotScene();
        }
        gameStore.setGameGlobalState(gameGlobalStates.none);
        soundService.stop(SoundTypes.JackpotSceneTransition);
        jackPotStore.setIsShowJackpot(false);
        setIsShowJackpotScene(true);
        //soundService.stop(SoundTypes.BackgroundMusic);
        soundService.play(SoundTypes.JackpotBackgroundMusic, { loop: true });
      },
      null,
      'end'
    );
  }, [setIsShowJackpotScene]);

  useEffect(() => {
    if (isShowJackpot) {
      const jackPotCongratsPopup = new Spine({ key: 'jackpotCongratsPopup' });
      jackPotCongratsPopupRef.current.addChild(jackPotCongratsPopup);
      if (isMobile()) {
        jackPotCongratsPopup.scale.set(Math.min(window.innerWidth / 540, window.innerHeight / 960));
      }
      jackPotCongratsPopup.x = isMobile() ? window.innerWidth / 2 : 720;
      jackPotCongratsPopup.y = isMobile() ? window.innerHeight / 2 : 405;
    }
  }, [isShowJackpot]);

  useEffect(() => {
    if (isShowJackpot) {
      applicationStore.setIsShowBlackLayer(true);
      soundService.play(SoundTypes.JackpotSceneTransition);
      const popup = jackPotCongratsPopupRef.current.children[0];
      popup.play('start');
      popup.addListener(
        'complete',
        () => {
          popup.play('loop', true);
          setTimeout(() => {
            hideJackPotCongratsPopup();
          }, 3000);
        },
        null,
        'start'
      );
    }
  }, [hideJackPotCongratsPopup, isShowJackpot]);

  if (!isShowJackpot) return null;

  return (
    <Container interactive ref={jackPotCongratsPopupRef} name='JackPotCongratsPopupContainer' />
  );
});

export default JackPotCongratsPopup;
